import { render, staticRenderFns } from "./CardConnect.vue?vue&type=template&id=1837fa31&"
import script from "./CardConnect.vue?vue&type=script&lang=js&"
export * from "./CardConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports